module.exports = __webpack_public_path__ + "img/index-section7-award8.60106175.png";